/* eslint-disable */
export default {
  mute: 'Mykistä',
  unmute: 'Poista mykistys',
  hangup: 'Lopeta puhelu',
  reject: 'Hylkää',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
